import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { RUN_STATUS } from "@/profitability/constants";
import { MissingNote, showValue } from "@/profitability/missing-value";
import type { EnrichedProfitabilityRun } from "@/profitability/types";

/**
 * A workbook-only run's figures, each as the Overview shows one: the missing
 * dash for a figure that is not there, and how many rows had no value.
 */
export const RunHeadline = ({ run }: { run: EnrichedProfitabilityRun }) => {
  // Guarded like the list's Result column. A run that failed after computing a
  // summary would otherwise show figures directly above "could not be built".
  if (
    run.status !== RUN_STATUS.completed ||
    !run.display.summary.length ||
    run.interactive_available
  )
    return null;
  return (
    <Stack direction="row" align="baseline" gap={6} className="flex-wrap">
      {run.display.summary.map((figure) => (
        <Stack align="start" key={figure.key} gap={0}>
          <Text variant="title" tabular>
            {showValue(figure.displayValue)}
          </Text>
          <MissingNote count={figure.missing} label={figure.label} />
          <Text variant="caption" tone="muted">
            {figure.label}
          </Text>
        </Stack>
      ))}
    </Stack>
  );
};
